import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";

function Footer({ onLoginClick }) {
  const { isLoggedIn, logout, userInfo } = useContext(AuthContext);

  const handleLoginClick = () => {
    const loginEvent = new Event("openLoginModal");
    window.dispatchEvent(loginEvent); // Dispatch global event
  };

  return (
    <footer className="footer bg-dark bg-faded-light">
      
      <div className="container pt-4 pb-3 pt-lg-5 pb-lg-4">
        <div className="row pt-2 pt-lg-0 justify-content-between">
          <div className="col-lg-1 pb-1 mb-2">
            <h3 className="h5 text-primary mb-1">XLR8</h3>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 offset-xl-1 mb-2 mb-sm-4">
            <h3 className="fs-base text-light">Buying &amp; Selling</h3>
            <ul className="list-unstyled fs-sm">
            <li>
                <a className="nav-link-light" href="/faq/buying-a-car">
                  Buying a Car
                </a>
              </li>
              <li>
                <a className="nav-link-light" href="/faq/selling-a-car">
                  Selling a Car
                </a>
              </li>
              <li>
                <a className="nav-link-light" href="/faq">
                  FAQs
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-2 mb-sm-4">
            <h3 className="fs-base text-light">Sellar</h3>
            <ul className="list-unstyled fs-sm">
              <li>
                <a className="nav-link-light" href="#">
                  Submit your car
                </a>
              </li>
              <li>
                <a className="nav-link-light" href="#">
                  Inspections
                </a>
              </li>
              <li>
                <a className="nav-link-light" href="#">
                  Photoshoot
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 mb-2 mb-sm-4">
            <h3 className="fs-base text-light">More to Explore</h3>
            <ul className="list-unstyled fs-sm">
              
              <li>
                <a className="nav-link-light" href="#">
                  Support
                </a>
              </li>
              <li>
                <a className="nav-link-light" href="#">
                  Financing
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xl-2 col-lg-3 col-sm-6 col-md-3 mb-2 mb-sm-4">
            <a
              className="d-flex align-items-center text-decoration-none mb-2"
              href="tel:4065550120"
            >
              <i className="fi-device-mobile me-2"></i>
              <span className="text-light">(123) 999-0000</span>
            </a>
            <a
              className="d-flex align-items-center text-decoration-none mb-2"
              href="mailto:example@email.com"
            >
              <i className="fi-mail me-2"></i>
              <span className="text-light">info@xlr8.com</span>
            </a>
            {/* 
            <div className="d-flex flex-wrap pt-4">
              <a
                className="btn btn-icon btn-translucent-light btn-xs rounded-circle mb-2 me-2"
                href="#"
              >
                <i className="fi-facebook"></i>
              </a>
              <a
                className="btn btn-icon btn-translucent-light btn-xs rounded-circle mb-2 me-2"
                href="#"
              >
                <i className="fi-twitter"></i>
              </a>
              <a
                className="btn btn-icon btn-translucent-light btn-xs rounded-circle mb-2 me-2"
                href="#"
              >
                <i className="fi-telegram"></i>
              </a>
              <a
                className="btn btn-icon btn-translucent-light btn-xs rounded-circle mb-2"
                href="#"
              >
                <i className="fi-messenger"></i>
              </a>
            </div>
            */}
          </div>
        </div>
      </div>
      <div className="container d-lg-flex align-items-center justify-content-between fs-sm pb-3">
        <div className="d-flex flex-wrap justify-content-center order-lg-2 mb-3">

          <a className="nav-link nav-link-light fw-normal me-3" href="#">
            Terms and Conditions
          </a>
         
        </div>
        <p className="text-center text-lg-start order-lg-1 mb-lg-0">
          <span className="text-light opacity-50">
            2025&copy; All rights reserved.
          </span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
